import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import responseStatus from './common/redux/reducers.responseStatus';
import auth from './auth/redux/reducers';
import forgotPw from './auth/redux/reducers.forgotPw';
import checkin from './checkins/redux/reducers';
import profile from './profile/redux/reducers';
import publicProfile from './publicUser/redux/reducers';
import notifications from './common/redux/reducers.notifications';
import signup from './auth/redux/reducers.signup';

const rootReducer = combineReducers({
  routing: routerReducer,
  responseStatus,
  auth,
  forgotPw,
  checkin,
  profile,
  notifications,
  signup,
  publicProfile
});

export default rootReducer;




// WEBPACK FOOTER //
// ./shared/reducers.js